// extracted by mini-css-extract-plugin
export default {"form":"ForgetPassword_form__uf5sW","body":"ForgetPassword_body__QZH8W","btn":"ForgetPassword_btn__pBWkE","para":"ForgetPassword_para__6VSyu"};